const _eightRandomCharacters = isDelimiterRequired => {
  const p = (Math.random().toString(16) + '000000000').substr(2, 8)
  return isDelimiterRequired ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
}

class CommonFunctionUtil {
  /**
   * Generates GUID string. Default value is without delimiter unless passed in as true
   * @example 9ae011df-d26e-4842-99a8-1a8d20dc4dd6 or 9ae011dfd26e484299a81a8d20dc4dd6
   */
  generateGUID(includeDelimiter = false) {
    return (
      _eightRandomCharacters() +
      _eightRandomCharacters(includeDelimiter) +
      _eightRandomCharacters(includeDelimiter) +
      _eightRandomCharacters()
    )
  }

  getTimeZone(tzDesignator) {
    let timeZone

    switch (tzDesignator) {
      case '-0400': {
        timeZone = 'EDT'
        break
      }
      case '-0700': {
        timeZone = 'MST'
        break
      }
      case '-0600': {
        timeZone = 'MDT'
        break
      }
      default: {
        timeZone = 'EST'
      }
    }

    return timeZone
  }
}

const commonFunctionUtil = new CommonFunctionUtil()

export { commonFunctionUtil as CommonFunctionUtil }
